// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import TableOutlined from '/Users/wunan/personal/FitNation-web/FitNation-web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { TableOutlined };
